import { useGetApiNotifications, } from '../../generated/sitComponents';
import { CACHE_TIMES } from '../query';
import { sortNotificationsDesc } from './helpers';
export function useGetNotifications(variables, options) {
    return useGetApiNotifications(variables, {
        staleTime: CACHE_TIMES.FIVE_SECONDS,
        gcTime: CACHE_TIMES.TEN_MINUTES,
        ...options,
        select: sortNotificationsDesc,
    });
}
//# sourceMappingURL=use-get-notifications.js.map